import { useState } from 'react';
import type { DevForcedReservationOutcome } from '@repo/domain';
import { setMockForcedOutcome } from '@repo/repo-mock';
import { type TestId } from '@repo/test-id';

interface Props {
  testId: TestId;
}

const OUTCOMES: DevForcedReservationOutcome[] = [
  'awaitsPayment',
  'paymentFailed',
  'paymentGatewayUnavailable',
  'spotTaken',
  'activeReservationExists',
  'parkingNotFound',
];

export default function DevForcedOutcomeSelect({ testId }: Props) {
  const [value, setValue] = useState<DevForcedReservationOutcome | undefined>(undefined);

  const handleChange = (nextValue: DevForcedReservationOutcome | undefined): void => {
    setValue(nextValue);
    setMockForcedOutcome(nextValue);
  };

  return (
    <div className="bg-primary mt-3 flex flex-col gap-2 rounded-3xl p-4">
      <label className="text-sm font-semibold" htmlFor="dev-forced-outcome">
        DEV: force reservation outcome
      </label>
      <select
        id="dev-forced-outcome"
        data-testid={testId.append('devForcedOutcome')}
        className="rounded-md border p-2 text-sm"
        value={value ?? ''}
        onChange={(event) => {
          const nextValue = event.target.value;
          handleChange(nextValue === '' ? undefined : (nextValue as DevForcedReservationOutcome));
        }}
      >
        <option value="">success</option>
        {OUTCOMES.map((outcome) => (
          <option key={outcome} value={outcome}>
            {outcome}
          </option>
        ))}
      </select>
    </div>
  );
}
